export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10 MB
export const MAX_VIDEO_SIZE = 100 * 1024 * 1024; // 100 MB for videos

export const ALLOWED_IMAGE_TYPES = [
  // Image MIME Types
  'image/jpeg', // .jpeg
  'image/jpg', // .jpg
  'image/png', // .png
  'image/gif', // .gif
  'image/svg+xml', // .svg
  'image/tiff', // .tif, .tiff
  'image/bmp', // .bmp
  'image/webp', // .webp

  // Document MIME Types
  // 'application/msword', // .doc
  // 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
  // 'application/pdf', // .pdf

  // Audio MIME Types
  // 'audio/mpeg', // .mp3
  // 'audio/wav', // .wav
  // 'audio/aac', // .aac
  // 'audio/ogg', // .ogg
  // 'audio/flac', // .flac

  // Video MIME Types
  // 'video/mp4', // .mp4
  // 'video/quicktime', // .mov
  // 'video/webm', // .webm
  // 'video/x-msvideo', // .avi
  // 'video/x-ms-wmv', // .wmv
  // 'video/x-flv', // .flv
  // 'video/x-matroska', // .mkv
] as const;

export const ALLOWED_VIDEO_TYPES = ['video/mp4', 'video/quicktime', 'video/webm'] as const;

// Combined array for contexts that allow both images and videos
export const ALLOWED_FILE_TYPES = [...ALLOWED_IMAGE_TYPES, ...ALLOWED_VIDEO_TYPES] as const;

// Legacy export - images only
export const ALLOWED_FILE_TYPES_IMAGES_ONLY = ALLOWED_IMAGE_TYPES;

export const MAX_FILES = 4;
